/*
 * File: cell-month.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import {
    ITableBodyCellData,
    defaultTableBodyCellData,
} from "../../../core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import CellDatetime from "../cell-datetime/cell-datetime";

// { year: "numeric", "month": "2-digit" }
const defaultData: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
};

@Component
@UITag.setDefault({
    uiSort: true,
    uiSearch: true,
})
export default class CellMonth extends CellDatetime {
    @Prop({ type: Object, required: false })
    declare data: (Intl.DateTimeFormatOptions & ITableBodyCellData) | undefined;

    get mergedData() {
        return {
            ...defaultTableBodyCellData,
            ...defaultData,
            ...this.data,
        };
    }
}
